
import imgMobileDev from './images/mobile_dev.jpg';
import imgWebAppDev from './images/webapp_dev.jpg';
import imgIoTDev from './images/iot_device.jpg';
import imgInternet from './images/internet.jpg';
import imgLogo from './images/1cs.svg';
import imgFront from './images/transformation.jpg';
import imgAbout from './images/aboutus.jpg';
import imgTechs from './images/web_tech.png';
import imgEvaluate from './images/client-info.jpg';
import imgAnalyze from './images/analysis.jpg';
import imgDesign from './images/app_design.jpg';
import imgDevelop from './images/develop.jpg';
import imgTesting from './images/QAtest.jpg';
import imgLaunch from './images/launch1.jpg';
import imgSupport from './images/support.jpg';

import {PageType, Position} from './types';
import {isMobile} from './utils';

const mobile = isMobile();
const background = 'white';
const color = 'gray';
const fontFamily = "'Palatino Linotype', 'Book Antiqua', Palatino, serif";
export const config = { 
    website:{
        title: 'One Click Systems',
        home: 'www.1cs.ca',
        style:{
            background: 'white',
        },
        header: {
            style:{
                background:'#f5f5f0',
                color: '#00a3cc',
                fontFamily : "'Bookman Header', serif",
                fontSize: '38px',
                fontWeight: '900',
                width: 'auto',
                margin: '1% 35%' 
            },
            icon: imgLogo,
            menu:{
                logo:{
                    style:{
                        background,
                        fontSize: '18px',
                        color,
                        margin: '12%',
                    },
                    show: false,
                },
                humburger:{
                    style:{
                        background: '#f5f5f0',
                        border: 'solid #ebebe0 2px',
                        fontSize: '18px',
                        margin: '1% 1%',
                        color,
                    },
                    show: true,
                    stuck: false,
                    autohide: true,
                }
            }
        },
        footer: { 
            style:{
                background,
                fontSize: '18px',
                color,
            },
            contact: [
                {
                    id:'mail',
                    text:'ladi@1cs.ca',
                    link: 'mailto:ladi@1cs.ca',
                },
                {
                    id:'phone',
                    text:'416-520-5285',
                },
            ],
            social:[
                // {
                //     id:'facebook',
                //     link: "https://www.facebook.com",
                // },
                // {
                //     id:'instagram',
                //     //text:'Instagram',
                //     link: "https://www.instagram.com",
                //     //icon: iconInstagram,
                // },
                // {
                //     id:'twitter',
                //     //text:'Twitter',
                //     link: "https://www.twitter.com",
                //     //icon: iconTwitter,
                // },
                // {
                //     id:'linkedin',
                //     link: "https://www.linkedin.com",
                // },
                // {
                //     id:'mail',
                //     link: 'mailto:ladi@1cs.ca',
                // },
            ]
        },
        page: { 
            style:{
                background,
                fontSize: '40px',
                color,
            },
        },
        pages:[
        {
            id:1, 
            type: PageType.FrontPage,
            noHeader: true,
            icon:'home', 
            title:'Home', 
            subtitle:'Your project is our #1 priority ', 
            link:'home', 
            image: imgFront,
            imgSize:'huge',
            text:'We offer software and hardware development.'
        },
        {
            id:2,
            type: PageType.Slider,
            icon:'emergency', 
            title:'Our Services',
            link:'services', 
            axis:'horizontal',   
            style:{
                //margin: 50,
                //border: 'solid 3px lightblue',
                //borderRadius: 3,
                //height: 200,
            },
            button:{
                color:'black',
                background:'white', 
                pos: '-10px',
                shape:'circle',
            },  
            slides:[
                {
                    id:1, 
                    name:'WebAppDev', 
                    image:imgWebAppDev,
                    text:'Software and Web Development'
                },
                {
                    id:2, 
                    name:'MobileDev', 
                    image:imgMobileDev,
                    text:'Mobile Application Development'
                },
                {
                    id:3, 
                    name:'WebsiteDesign', 
                    image:imgInternet,
                    text:'Website Design'
                },
                {
                    id:4, 
                    name:'IoTDev', 
                    image:imgIoTDev,
                    text:'Internet Of Things'
                },
               ]
        },
        {
            id:3, 
            type: PageType.SimplePage,
            icon:'cogs', 
            title:'Working Process', 
            link:'workProcess', 
            style:{
                margin: 5,
                border: 'solid 2px lightgray',
                borderRadius: 5,
                background:'#f5f5f0', 
            },
            paragraph: {
                style:{
                    fontFamily: "'Palatino Linotype', 'Book Antiqua', Palatino, serif",
                    fontSize: '32px',
                    fontWeight: '900',
                    lineHeight: '1.3',
                    color: '#604020'
                },
            },
            paragraphs:[
                {
                    title:'Evaluate', 
                    image: imgEvaluate, 
                    imgPos:Position.LEFT, 
                    imgSize: 'large',
                    text:'We closely examine your needs and goals and ensure we have a top-to-bottom understanding of your dream product.'
                },
                {
                    title:'Analyze', 
                    image: imgAnalyze,
                    imgPos:Position.RIGHT,
                    imgSize: 'large',
                    text:'By working closely with our clients, 1CS ensures that we make use of the most well suited and optimized technology for each project.'
                },
                {
                    title:'Design', 
                    image: imgDesign, 
                    imgPos:Position.LEFT, 
                    imgSize: 'large',
                    text:'Our specialty is future-proof, expandable products which are not just ready for the next generation, but the one after as well.'
                },
                {
                    title:'Develop', 
                    image: imgDevelop,
                    imgPos:Position.RIGHT,
                    imgSize: 'large',
                    text:'We offer front-end and back-end solutions to create powerful, scalable software that is both impressive and easy to use with maintainable code.'
                },
                {
                    title:'Testing', 
                    image: imgTesting, 
                    imgPos:Position.LEFT,
                    imgSize: 'large',
                    text:'Our team will put every solution we present through a gauntlet of tests and checks to make sure it is up to and above your standards and requirements.'
                },
                {
                    title:'Launch', 
                    image: imgLaunch,
                    imgPos:Position.RIGHT,
                    imgSize: 'large',
                    text:'We will provide unwavering support throughout the pilot phase, which we view as one of the most important parts of our process.'
                },
                {
                    title:'Support', 
                    image: imgSupport, 
                    imgPos:Position.LEFT,
                    imgSize: 'large',
                    text:'At 1CS we never quit. As your needs evolve, we will be here to bring continuous proactive aid.'
                },
              ]
        },
        // {
        //     id:7, 
        //     type: PageType.ColumnsPage,
        //     icon:'folder', 
        //     title:'ColumnsPage', 
        //     link:'columnsPage', 
        //     columns:[
        //         {
        //             title:'Column1', 
        //             subtitle:'', 
        //             image:imgMobileDev, 
        //             text:'Text1'},
        //         {
        //             title:'Column2', 
        //             subtitle:'', 
        //             image:imgWebAppDev, 
        //             text:'Text2'},
        //         {
        //             title:'Column3', 
        //             subtitle:'', 
        //             image:imgFront, 
        //             text:'Text3'},
        //        ]
        // },
        {
            id:5, 
            type: PageType.SimpleCard,
            icon:'file code outline', 
            title:'Our Tech Specs', 
            subtitle:'', 
            link:'techs', 
            image:imgTechs,
            text:'HTML, CSS, Javascript, React, React-Native, C#, ASP.NET, Java, Wordpress, C++, SQL',
            animation: 'bounceIn infinite 10s',
            style:{
                fontFamily: "'Palatino Linotype', 'Book Antiqua', Palatino, serif",
                fontSize: mobile ? '16px': '28px',
                fontWeight: '300',
                lineHeight: '1.5',
            },
        },     
        {
            id:6, 
            type: PageType.SimpleCard,
            icon:'user', 
            title:'About Us', 
            subtitle:'', 
            link:'about', 
            image:imgAbout,
            text:'Our team has 20 years of experience in software development, user interface design, testing and support of web and desktop applications. We combine knowledge and experience of our senior developers with modern ideas and approach of new graduate developers.',
            animation: 'bounceIn infinite 10s',
            style:{
                fontFamily: "'Palatino Linotype', 'Book Antiqua', Palatino, serif",
                fontSize: mobile ? '16px': '28px',
                fontWeight: '300',
                lineHeight: '1.5',
            },
        },
       ]
    }
};
export default config;


// WEBPACK FOOTER //
// ./src/config.js